module.exports = "<article>\r\n     <app-stolen-car></app-stolen-car>\r\n</article>\r\n\r\n"